import { render, staticRenderFns } from "./company-card.vue?vue&type=template&id=ad2b8c4e&"
import script from "./company-card.vue?vue&type=script&lang=js&"
export * from "./company-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports